let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6YgN9")).then(() => parcelRequire('6V6D9'));